import { useMemo } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { generatePath, useNavigate } from 'react-router'

import { actions, selectors } from '../../redux'
import { app } from '../../configuration'
import { routesPath } from '../../router'

import { HeaderProps } from '.'

export const useHeaderProps = (): HeaderProps => {
  const dispatch = useDispatch()
  const navigate = useNavigate()
  const currentLocale = useSelector(selectors.app.currentLocale)

  return useMemo(
    () => ({
      localeSelect: {
        name: 'locale',
        value: currentLocale,
        options:
          app.AVAILABLE_LOCALES.map((locale) => ({
            label: locale,
            value: locale,
          })) ?? [],
        onChange: (e) => {
          navigate(generatePath(routesPath.home, { locale: e.target.value }))
          dispatch(actions.app.switchLocale(e.target.value))
        },
      },
    }),
    [currentLocale, dispatch, navigate]
  )
}
